import { useMemo } from 'react';
import {
  ExpressionType,
  type IExpression,
} from '../../../../schema/expressions/IExpression.ts';
import { type IReference } from '../../../../schema/expressions/references/IReference.ts';
import { useExpressionValue } from '../../../../schema/expressions/render/hooks/useExpressionValue.tsx';
import { useWidgetScopeContext } from '../../../../schema/form/fillable/WidgetScopeContext.tsx';

export interface IComputeReferenceNodeRenderProps {
  reference: IReference;
  preview?: boolean;
}

/**
 * Visualizza il valore di un nodo di tipo `ComputeExpressionReferenceNode`
 */
export function ComputeReferenceNodeRender(
  props: IComputeReferenceNodeRenderProps,
) {
  const { reference, preview } = props;

  const widgetScope = useWidgetScopeContext();
  // Creiamo un path "virtuale" per il nodo corrente; ci serve perché potenzialmente
  // il nodo può essere in un widget che non è _valoriale_ (`widgetType.hasValue = false`),
  // il che significa che non ha un nome.
  // TODO IN futuro semplificare questa logica, potremo prendere in ingresso _solo_ il prefix
  const basePath = `${widgetScope.prefix ?? ''}virtualNode`;

  // Memoizziamo per evitare rerender
  const expressionResolverParams: IExpression = useMemo(
    () => ({
      type: ExpressionType.Reference,
      value: reference,
    }),
    [reference],
  );

  const value = useExpressionValue(basePath, expressionResolverParams);

  // In caso di preview mostriamo il codice della reference, non possiamo
  // mostrare il valore perché non abbiamo il contesto di valutazione
  if (preview) {
    return (
      <span className="compute-expression-reference">@{reference.label}</span>
    );
  }

  if (value.type !== 'value') return null;
  if (value.result == null) return '';

  // TODO Formattare il valore in base al tipo di dato
  return `${value.result}`; // NOSONAR
}
